import React from "react";

import { SwipeableDrawer } from "@mui/material";

import Toolbar from "@mui/material/Toolbar";
import Typography from "@mui/material/Typography";
import ChevronLeftIcon from "@mui/icons-material/ChevronLeft";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import Divider from "@mui/material/Divider";

import { Drawer } from "./Drawer";
import Sidebar from "../sidebar/Sidebar";
import CustomButton from "../../../../helper-components/input/CustomButton";

import { getLanguage } from "../../../../config/language/language.js";

/**
 * The master sidebar component, so to speak.
 */
export default function AppDrawer(props) {
    const isMobile = props.browser.isMobile;

    const toolbar = (
        <>
            <Toolbar
                className="tour-about-3"
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "flex-end",
                    px: 3
                }}>
                <Typography variant="subtitle1" mr={1}>
                    <strong>{props.sidebar.openAppDrawer ? getLanguage().SIDEBAR_TITLE : ""}</strong>
                </Typography>
                <CustomButton
                    icon={props.sidebar.openAppDrawer ? <ChevronLeftIcon /> : <ChevronRightIcon />}
                    onClick={props.sidebar.toggleAppDrawer}
                    tooltip="Open / close sidebar"
                />
            </Toolbar>

            <Divider />

            <Sidebar {...props} />
        </>
    );

    // Render swipeable drawer for mobile.
    if (isMobile) {
        return (
            <SwipeableDrawer
                open={props.sidebar.openAppDrawer}
                onClose={props.sidebar.toggleAppDrawer}
                onOpen={props.sidebar.toggleAppDrawer}
                className="sticky-sidebar-mobile"
                sx={{ zIndex: 1300 }}>
                {toolbar}
            </SwipeableDrawer>
        );
    }

    // Render mini-icon variant permanent drawer for other devices.
    return (
        <Drawer variant="permanent" open={props.sidebar.openAppDrawer} className="sticky-sidebar">
            {toolbar}
        </Drawer>
    );
}
